import { gql } from "@apollo/client"

// export const GET_ESCROW_TRACKING_BY_ID = gql`
// query GetStriveEscrowTracking($propertyId: ID) {
//   getStriveEscrowTracking(property_id: $propertyId) {
//     arcimedes_row_id
//     property_id
//     deleted
//     task
//     title_company
//     escrow_officer
//     psa_sent_to_buyer
//     psa_sent_to_buyer_checkbox
//     have_all_due_diligence_materials
//     effective_date
//     effective_date_checkbox
//     rofr_notice_sent_to_tenant
//     rofr_notice_sent_to_tenant_checkbox
//     rofr_waiver_sent_to_buyerside__title_co
//     rofr_waiver_sent_to_buyerside__title_co_checkbox
//     psa_sent_to_title
//     psa_sent_to_title_checkbox
//     survey_sent_to_title
//     survey_sent_to_title_checkbox
//     receipted_psa_received__sent_to_buyers_agent
//     receipted_psa_received__sent_to_buyers_agent_checkbox
//     dd_site_created__access_granted
//     dd_site_created__access_granted_checkbox
//     updated_db__istrive
//     updated_to_uc_on_externals
//     wiring_instructions_sent_to_buyeragent
//     earnest_money_received
//     earnest_money_received_checkbox
//     has_title_approved_survey
//     survey_ordered
//     survey_ordered_checkbox
//     received_title_commitment
//     received_title_commitment_checkbox
//     buyers_title_objections_due
//     buyers_title_objections_due_checkbox
//     seller_response_to_buyer_objections
//     seller_response_to_buyer_objections_checkbox
//     title_objection_period
//     title_objection_period_checkbox
//     financing_application_deadline
//     financing_application_deadline_checkbox
//     feasibility_period
//     feasibility_extension
//     feasibility_period_expires__deposit_nonrefundable
//     feasibility_period_expires__deposit_nonrefundable_checkbox
//     financing_approval
//     financing_approval_checkbox
//     financing_period_ends
//     financing_period_ends_checkbox
//     additional_earnest_money_received
//     additional_earnest_money_received_checkbox
//     estoppelsnda_requested_from_lender_buyer_or_tenant
//     estoppelsnda_requested_from_lender_buyer_or_tenant_checkbox
//     estoppelssdna_due
//     estoppelssdna_due_checkbox
//     verify_close_10_days_before_closing
//     verify_close_10_days_before_closing_checkbox
//     send_title_invoice_wire_cam_deposits_prorations
//     send_title_invoice_wire_cam_deposits_prorations_checkbox
//     update_insurance_certificates
//     update_insurance_certificates_checkbox
//     title_sent_out_closing_statements_for_review
//     title_sent_out_closing_statements_for_review_checkbox
//     closing_period
//     closing_extension
//     closing_date
//     closing_date_checkbox
//     arcimedes_created
//     arcimedes_created_by
//     arcimedes_modified
//     arcimedes_modified_by
//   }
// }
// `


export const GET_ESCROW_TRACKING_BY_ID = gql`
query GetStriveEscrowTracking($propertyId: ID) {
  getStriveEscrowTrackingByPropertyId(property_id: $propertyId) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      PROPERTY_ID
      DELETED
      TASK
      TITLE_COMPANY
      ESCROW_OFFICER
      PSA_SENT_TO_BUYER
      PSA_SENT_TO_BUYER_CHECKBOX
      HAVE_ALL_DUE_DILIGENCE_MATERIALS
      EFFECTIVE_DATE
      EFFECTIVE_DATE_CHECKBOX
      ROFR_NOTICE_SENT_TO_TENANT
      ROFR_NOTICE_SENT_TO_TENANT_CHECKBOX
      ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO
       ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO_CHECKBOX
      PSA_SENT_TO_TITLE
      PSA_SENT_TO_TITLE_CHECKBOX
      SURVEY_SENT_TO_TITLE
      SURVEY_SENT_TO_TITLE_CHECKBOX
      RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT
      RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT_CHECKBOX
      DD_SITE_CREATED__ACCESS_GRANTED
      DD_SITE_CREATED__ACCESS_GRANTED_CHECKBOX
      UPDATED_DB__ISTRIVE
      UPDATED_TO_UC_ON_EXTERNALS
      WIRING_INSTRUCTIONS_SENT_TO_BUYERAGENT
      EARNEST_MONEY_RECEIVED
      EARNEST_MONEY_RECEIVED_CHECKBOX
      HAS_TITLE_APPROVED_SURVEY
      SURVEY_ORDERED
      SURVEY_ORDERED_CHECKBOX
      RECEIVED_TITLE_COMMITMENT
      RECEIVED_TITLE_COMMITMENT_CHECKBOX
      BUYERS_TITLE_OBJECTIONS_DUE
      BUYERS_TITLE_OBJECTIONS_DUE_CHECKBOX
      SELLER_RESPONSE_TO_BUYER_OBJECTIONS
      SELLER_RESPONSE_TO_BUYER_OBJECTIONS_CHECKBOX
      TITLE_OBJECTION_PERIOD
      TITLE_OBJECTION_PERIOD_CHECKBOX
      FINANCING_APPLICATION_DEADLINE
      FINANCING_APPLICATION_DEADLINE_CHECKBOX
      FEASIBILITY_PERIOD
      FEASIBILITY_EXTENSION
      FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE
      FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE_CHECKBOX
      FINANCING_APPROVAL
      FINANCING_APPROVAL_CHECKBOX
      FINANCING_PERIOD_ENDS
      FINANCING_PERIOD_ENDS_CHECKBOX
      ADDITIONAL_EARNEST_MONEY_RECEIVED
      ADDITIONAL_EARNEST_MONEY_RECEIVED_CHECKBOX
      ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT
      ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT_CHECKBOX
      ESTOPPELSSDNA_DUE
      ESTOPPELSSDNA_DUE_CHECKBOX
      VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING
      VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING_CHECKBOX
      SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS
      SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS_CHECKBOX
      UPDATE_INSURANCE_CERTIFICATES
      UPDATE_INSURANCE_CERTIFICATES_CHECKBOX
      TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW
      TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW_CHECKBOX
      CLOSING_PERIOD
      CLOSING_EXTENSION
      CLOSING_DATE
      CLOSING_DATE_CHECKBOX
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
      BUYER_FIRST_NAME
      BUYER_LAST_NAME
      BUYER_COMPANY_NAME
      BUYER_COMPANY_STATE
      FIRM_NAME
      TEAM_FIRST_NAME
      TEAM_LAST_NAME
      AGENT_FIRST_NAME
      AGENT_LAST_NAME
      NEGOTIATION_PRICE
      NEGOTIATION_CAP_RATE
      SELLER_FIRST_NAME
      SELLER_LAST_NAME
      LISTING_AGENT_1_EMAIL
      LISTING_AGENT_2_EMAIL
      LISTING_AGENT_3_EMAIL
      BUYER_AGENT_1_EMAIL
      BUYER_AGENT_2_EMAIL
      BUYER_AGENT_3_EMAIL
      SELLER_COMPANY_NAME
      LISTING_AGENT_NAME
    }
    error
  }
}
`

export const GET_ESCROW_TRACKING_LIST = gql`
query GetStriveEscrowTrackingList {
  getStriveEscrowTrackingList {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      PROPERTY_ID
      DELETED
      TASK
      TITLE_COMPANY
      ESCROW_OFFICER
      PSA_SENT_TO_BUYER
      PSA_SENT_TO_BUYER_CHECKBOX
      HAVE_ALL_DUE_DILIGENCE_MATERIALS
      EFFECTIVE_DATE
      EFFECTIVE_DATE_CHECKBOX
      ROFR_NOTICE_SENT_TO_TENANT
      ROFR_NOTICE_SENT_TO_TENANT_CHECKBOX
      ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO
      ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO_CHECKBOX
      PSA_SENT_TO_TITLE
      PSA_SENT_TO_TITLE_CHECKBOX
      SURVEY_SENT_TO_TITLE
      SURVEY_SENT_TO_TITLE_CHECKBOX
      RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT
      RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT_CHECKBOX
      DD_SITE_CREATED__ACCESS_GRANTED
      DD_SITE_CREATED__ACCESS_GRANTED_CHECKBOX
      UPDATED_DB__ISTRIVE
      UPDATED_TO_UC_ON_EXTERNALS
      WIRING_INSTRUCTIONS_SENT_TO_BUYERAGENT
      EARNEST_MONEY_RECEIVED
      EARNEST_MONEY_RECEIVED_CHECKBOX
      HAS_TITLE_APPROVED_SURVEY
      SURVEY_ORDERED
      SURVEY_ORDERED_CHECKBOX
      RECEIVED_TITLE_COMMITMENT
      RECEIVED_TITLE_COMMITMENT_CHECKBOX
      BUYERS_TITLE_OBJECTIONS_DUE
      BUYERS_TITLE_OBJECTIONS_DUE_CHECKBOX
      SELLER_RESPONSE_TO_BUYER_OBJECTIONS
      SELLER_RESPONSE_TO_BUYER_OBJECTIONS_CHECKBOX
      TITLE_OBJECTION_PERIOD
      TITLE_OBJECTION_PERIOD_CHECKBOX
      FINANCING_APPLICATION_DEADLINE
      FINANCING_APPLICATION_DEADLINE_CHECKBOX
      FEASIBILITY_PERIOD
      FEASIBILITY_EXTENSION
      FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE
      FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE_CHECKBOX
      FINANCING_APPROVAL
      FINANCING_APPROVAL_CHECKBOX
      FINANCING_PERIOD_ENDS
      FINANCING_PERIOD_ENDS_CHECKBOX
      ADDITIONAL_EARNEST_MONEY_RECEIVED
      ADDITIONAL_EARNEST_MONEY_RECEIVED_CHECKBOX
      ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT
      ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT_CHECKBOX
      ESTOPPELSSDNA_DUE
      ESTOPPELSSDNA_DUE_CHECKBOX
      VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING
      VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING_CHECKBOX
      SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS
      SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS_CHECKBOX
      UPDATE_INSURANCE_CERTIFICATES
      UPDATE_INSURANCE_CERTIFICATES_CHECKBOX
      TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW
      TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW_CHECKBOX
      CLOSING_PERIOD
      CLOSING_EXTENSION
      CLOSING_DATE
      CLOSING_DATE_CHECKBOX
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
      BUYER_FIRST_NAME
      BUYER_LAST_NAME
      BUYER_COMPANY_NAME
      BUYER_COMPANY_STATE
      FIRM_NAME
      TEAM_FIRST_NAME
      TEAM_LAST_NAME
      AGENT_FIRST_NAME
      AGENT_LAST_NAME
      NEGOTIATION_PRICE
      NEGOTIATION_CAP_RATE
      SELLER_FIRST_NAME
      SELLER_LAST_NAME
      SELLER_COMPANY_NAME
      LISTING_AGENT_NAME
      LISTING_AGENT_1_EMAIL
      LISTING_AGENT_2_EMAIL
      LISTING_AGENT_3_EMAIL
      BUYER_AGENT_1_EMAIL
      BUYER_AGENT_2_EMAIL
      BUYER_AGENT_3_EMAIL
    }
    error
  }
}
`